// src/services/poaSeguimientoService.js
import axios from 'axios';
import config from '../../config';

const baseUrl = config.baseUrl;
const poaEndpoint = '/api/poa-seguimiento';

const poaSeguimientoService = {
  /**
   * Obtener todos los registros de poa_seguimiento
   * @returns {Promise<Array>} Lista de poa_seguimiento
   */
  async getAll() {
    try {
      const response = await axios.get(`${baseUrl}${poaEndpoint}`);
      return response.data;
    } catch (error) {
      console.error('Error en getAll PoaSeguimiento:', error);
      throw error;
    }
  }
};

export default poaSeguimientoService;
